const n = {
  danger: "ban",
  info: "info-square",
  success: "check",
  warning: "exclamation-triangle"
};
export {
  n as ALERT_ICONS
};
